import { DateTime } from "luxon";

// Booking dates are fake UTC (club wall clock labeled Z).
export const wall = (iso) => DateTime.fromISO(iso, { zone: "utc" });

// Same window shape as the server: a 1-month validity starting Jan 1 ends
// Jan 31, not Feb 1.
export const windowEnd = (startDay, dur, unit) => startDay.plus({ [unit]: dur }).minus({ days: 1 }).endOf("day");
